export default __webpack_public_path__ + "static/media/Inkedjessica-biel_LI.2b843da5.jpg";